import { elements } from '@ecosystem/newron-design-system';
import React from 'react';
import { FilterAction } from './FilterAction';
import { ButtonProps } from './types';

const { Icon } = elements;

export function ShareAction(props: ButtonProps) {
  return (
    <FilterAction label="Share" {...props}>
      <Icon.icons.Share />
    </FilterAction>
  );
}
